import { HttpInsuranceProductService } from './../../../../service/http-insurance-product.service';
import { InsurancePremiumRecipientDto, PolicyBeneficiaryDto, PolicyCreatePayload, PolicyDependantDto, PolicyDto, ProductDto, ProductExtendedDto, ProductOfferDto, ProductOfferLineDto, ProductRuleDto } from './../../../../service/dto-insurance';
import { Component } from '@angular/core';
import { AgentDto, DependantDto, EmployerDto, MemberDto, ResultListDto } from '../../../../service/dto';
import { finalize, forkJoin, Subscription, switchMap, tap } from 'rxjs';
import { Filter, OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { HttpMemberService } from '../../../../service/http-member.service';
import { HierarchyService } from '../../../../service/hierarchy.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PolicyExtendedCoverModalComponent } from '../components/policy-extended-cover-modal/policy-extended-cover-modal.component';
import { HttpInsurancePolicyService } from '../../../../service/http-insurance-policy.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { PolicyAddDependantModalComponent } from '../components/policy-add-dependant-modal/policy-add-dependant-modal.component';
import { HttpEmployerService } from '../../../../service/http-employer.service';

export interface RuleResult {
	ruleType: string;
	passed: boolean;
	reason?: string;
}
export interface DependantWrapper {
	dependant: DependantDto;
	extended?: ProductExtendedDto;
	fromDate?: Date;
	selected: boolean;
	eligible: boolean;
	age: number;
	failedRules: RuleResult[];
}

@Component({
	selector: 'app-policy-new',
	standalone: false,
	templateUrl: './policy-new.component.html',
	styleUrl: './policy-new.component.scss'
})
export class PolicyNewComponent {
	//===========================================
	//SEARCH MEMBER
	//===========================================
	memberSearchData?: ResultListDto<MemberDto>;
	memberSearchPageIndex = 1;
	memberSearchPageSize = 10;
	memberSearchAppliedFilters: any = {};

	memberSearchFilters: Filter[] = [
		{ label: 'ID Number', name: 'idNumber', type: 'Text', format: '^\\w+$' },
		{ label: 'Name', name: 'name', type: 'Text', format: '^\\w.*$' },
		{ label: 'Surname', name: 'surname', type: 'Text', format: '^\\w.*$' },
		{ label: 'Msisdn', name: 'msisdn', type: 'Text', format: '^\\w.*$' },
		{ label: 'Email Address', name: 'emailAddress', type: 'Text', format: '^\\w.*$' },
		// { label: 'Membership Number', name: 'membershipNumber', type: 'Text', format: '^\\w.*$' }
		{ label: 'Personnel Number', name: 'personnelNumber', type: 'Text', format: '^\\w.*$' }
	];
	memberSearchColumnRef: TableColumn[] = [
		{ "title": "Name", "property": "name" },
		{ "title": "Last Name", "property": "surname" },
		{ "title": "Msisdn", "property": "msisdn" },
		{ "title": "Email Address", "property": "emailAddress" },
		{ "title": "ID Number", "property": "idNumber" },
		{ "title": "Date of Birth", "property": "dateOfBirth" },
	];

	//===========================================
	//SEARCH PRODUCT
	//===========================================
	productSearchData?: ResultListDto<ProductDto>;
	productSearchAppliedFilters: any = {};

	productSearchFilters: Filter[] = [
		{ label: 'Product Name', name: 'productName', type: 'Text', format: '^\\w+$' },
		{ label: 'Product Type', name: 'productType', type: 'Text', format: '^\\w.*$' },
		{ label: 'Policy Group', name: 'policyGroup', type: 'Text', format: '^\\w.*$' },
		{ label: 'Underwriter', name: 'underwriter', type: 'Text', format: '^\\w.*$' },
		{ label: 'Employer', name: 'employer', type: 'Text', format: '^\\w.*$' },
		{ label: 'Offer Name', name: 'productOfferName', type: 'Text', format: '^\\w+$' }
	];
	productSearchColumnRef: TableColumn[] = [
		{ "title": "Product", "property": "name" },
		{ "title": "Type", "property": "productType" },
		{ "title": "Offer", "cellRef": "offersRef" }
	];


	currencyFormatter = (value: number) => `R ${value}`;
	currencyParser = (value: string) => value.replace(/R\s?/, '') as any;
	compareById = (o1: any, o2: any): boolean => o1?.id === o2?.id;

	member?: MemberDto;
	product?: ProductDto;
	productOffer?: ProductOfferDto;
	loading = false;
	subscription = new Subscription();
	policyForm?: FormGroup;
	dependants: DependantDto[] = [];
	dependantWrappers: DependantWrapper[] = [];

	availablePolicyGroups: InsurancePremiumRecipientDto[] = [];
	availableEmployers: EmployerDto[] = [];


	constructor(
		private httpServiceMemberService: HttpMemberService,
		private httpServiceProductService: HttpInsuranceProductService,
		private httpServicePolicyService: HttpInsurancePolicyService,
		private httpEmployerService: HttpEmployerService,
		private hierarchyService: HierarchyService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder,
		private modalService: NzModalService,
		private currencyPipe: CurrencyPipe) {

	}


	ngOnInit(): void {
		this.memberSearchAppliedFilters['pageIndex'] = this.memberSearchPageIndex;
		this.memberSearchAppliedFilters['pageSize'] = this.memberSearchPageSize;

		forkJoin({
			premiumRecipients: this.httpServiceProductService.getPremiumRecipients(),
			employers: this.httpEmployerService.getAll()
		}).subscribe(({ premiumRecipients, employers }) => {
			this.availablePolicyGroups = premiumRecipients.filter(item => item.type === 'InsurancePolicyGroup');
			this.availableEmployers = employers;
		});

		this.subscription.add(this.hierarchyService.hierarchy$
			.pipe(
				tap(() => this.loading = true),
				switchMap(() => this.httpServiceMemberService.findMembers(this.memberSearchAppliedFilters, this.memberSearchPageIndex, this.memberSearchPageSize)),
			)
			.subscribe({
				next: result => {
					this.member = undefined;
					this.product = undefined;
					this.memberSearchData = result;
					this.loading = false;
				},
				error: err => {
					this.loading = false;
				}
			}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doFetchResultForMemberSearch(input: OnTableChange) {
		const appliedFilters = {
			idNumber: input.filters.filter(i => i.name == 'idNumber')[0]?.value,
			name: input.filters.filter(i => i.name == 'name')[0]?.value,
			surname: input.filters.filter(i => i.name == 'surname')[0]?.value,
			msisdn: input.filters.filter(i => i.name == 'msisdn')[0]?.value,
			emailAddress: input.filters.filter(i => i.name == 'emailAddress')[0]?.value,
			// membershipNumber: input.filters.filter(i => i.name == 'membershipNumber')[0]?.value,
			personnelNumber: input.filters.filter(i => i.name == 'personnelNumber')[0]?.value,

			pageIndex: input.pageIndex,
			pageSize: input.pageSize
		};
		if (JSON.stringify(this.memberSearchAppliedFilters) == JSON.stringify(appliedFilters)) {
			return;
		}
		this.memberSearchAppliedFilters = appliedFilters;

		this.memberSearchPageIndex = input.pageIndex;
		this.memberSearchPageSize = input.pageSize;
		this.loading = true;



		this.httpServiceMemberService.findMembers(this.memberSearchAppliedFilters, this.memberSearchPageIndex, this.memberSearchPageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.member = undefined;
				this.product = undefined;
				this.memberSearchData = result;
			});
	}
	doFetchResultForProductSearch(input: OnTableChange) {
		const appliedFilters = {
			productName: input.filters.filter(i => i.name == 'productName')[0]?.value,
			productType: input.filters.filter(i => i.name == 'productType')[0]?.value,
			policyGroup: input.filters.filter(i => i.name == 'policyGroup')[0]?.value,
			underwriter: input.filters.filter(i => i.name == 'underwriter')[0]?.value,
			employer: input.filters.filter(i => i.name == 'employer')[0]?.value,
			productOfferName: input.filters.filter(i => i.name == 'productOfferName')[0]?.value,
			memberId: this.member!.id
		};
		if (JSON.stringify(this.productSearchAppliedFilters) == JSON.stringify(appliedFilters)) {
			return;
		}
		this.productSearchAppliedFilters = appliedFilters;
		this.loading = true;



		this.httpServiceProductService.findProductsForMember(this.productSearchAppliedFilters)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.productSearchData = result;
			});
	}
	get isDependantEnabled(): boolean {
		if (!this.product) {
			return false;
		}
		return this.product.productType == 'Funeral';
	}
	setMember(input: MemberDto) {
		this.member = input;
		this.httpServiceMemberService.getFull(this.member.id).subscribe(result => {
			this.member = result;
			this.dependants = [...this.member.dependants];
			this.wrapDependants();
		});
		this.doFetchResultForProductSearch({ filters: [], pageIndex: 1, pageSize: 1000 });
	}
	setProduct(input: ProductDto) {
		this.product = input;
		this.productOffer = input.offers[0];

		this.policyForm = this.fb.group({
			policyNumber: [''],
			policyNumberAlt: [''],
			policyNumberOwls: [''],
			policyNumberIndustry: [''],
			policyNumberMembership: [''],
			currentSalary: [null],
			currentLoanAmount: [null],
			jobTitle: [null],
			occupation: [null],
			occupationDate: [null],
			employer: [null],
			policyGroup: [null],
			fromDate: [new Date(), Validators.required],
		});
		// beneficiaries?: PolicyBeneficiaryDto[] ;
		// employer?: EmployerDto ;
		// policyGroup?: InsurancePremiumRecipientDto ;
		this.wrapDependants();
	}

	getCurrentStep(): number {
		if (!this.member) {
			return 0;
		}
		if (!this.product && !this.productOffer) {
			return 1;
		}
		return 2;
	}

	wrapDependants() {
		if (this.member && this.product) {
			this.dependantWrappers = this.dependants.map(d => this.wrapDependant(d))
				.sort((i1, i2) => {
					if (i1.eligible != i2.eligible) {
						return i1.eligible ? -1 : 1;
					}
					let out = i1.dependant.surname.localeCompare(i2.dependant.surname);
					if (out != 0) {
						return out;
					}
					return i1.dependant.name.localeCompare(i2.dependant.name);
				});
		}
	}
	wrapDependant(dependant: DependantDto): DependantWrapper {
		const applicableRules = [...this.product!.rules, ...this.productOffer!.rules]
			.filter(item => item.appliedTo === dependant.relationship || item.appliedTo === 'All');
		const failedRules: RuleResult[] = [];
		if (!dependant.relationshipIsClose) {
			failedRules.push({
				ruleType: 'Relationship',
				passed: false,
				reason: `${dependant.relationship} dependants are only allowed extended cover.`
			});
		}

		for (const rule of applicableRules) {
			const passed = this.evaluateRule(rule, dependant);

			if (!passed) {
				failedRules.push({
					ruleType: rule.ruleType,
					passed: false,
					reason: this.getFailureReason(rule, dependant)
				});
			}
		}
		console.log("Validate Dependant: " + dependant, failedRules);
		return {
			dependant: dependant,
			eligible: dependant.relationshipIsClose && failedRules.length === 0,
			failedRules: failedRules,
			selected: failedRules.length === 0,
			extended: undefined,
			age: this.calculateAge(dependant.dateOfBirth)
		};
	}
	evaluateRule(rule: ProductRuleDto, dependant: DependantDto): boolean {
		const age = this.calculateAge(dependant.dateOfBirth);

		switch (rule.ruleType) {

			case 'EntryAgeFrom':
				return age >= rule.threshold;

			case 'EntryAgeTo':
				return age <= rule.threshold;

			case 'MinAge':
				return age >= rule.threshold;

			case 'MaxAge':
				return age <= rule.threshold;

			case 'InstanceCount':
			case 'WaitingPeriodSuicide':
			case 'WaitingPeriodAccidental':
			case 'WaitingPeriodNatural':
				return true;
			default:
				return true;
		}
	}



	calculateAge(dob: Date): number {
		const today = new Date();
		const birth = new Date(dob);

		let age = today.getFullYear() - birth.getFullYear();
		const m = today.getMonth() - birth.getMonth();

		if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
			age--;
		}

		return age;
	}
	getFailureReason(rule: ProductRuleDto, dependant: DependantDto): string {
		const age = this.calculateAge(dependant.dateOfBirth);
		switch (rule.ruleType) {
			case 'MinAge':
				return `Dependants age of${age} is below the minimum allowed age of ${rule.threshold}.`;
			case 'MaxAge':
				return `Dependants age of${age} is above the maximum allowed age of ${rule.threshold}.`;
			case 'EntryAgeFrom':
				return `Dependants age of${age} is below the minimum allowed entry age of ${rule.threshold}.`;
			case 'EntryAgeTo':
				return `Dependants age of${age} is above the maximum allowed entry age of ${rule.threshold}.`;
			default:
				return `Failed ${rule.ruleType}.  Age:[${age}]`;
		}
	}

	getOfferLinePrice(input: ProductOfferLineDto): string {
		const detail = input.details[0];
		if (detail.premiumType == 'Fixed') {
			return this.currencyPipe.transform(detail.premiumAmount, 'ZAR', 'symbol-narrow')!;;
		}
		const monthlySalary = this.policyForm!.get('currentSalary')?.value;
		if (detail.premiumPercentageProperty == 'client.monthlySalary') {
			if (!monthlySalary) {
				return `${detail.premiumAmount} % of Current Salary`
			}
			const out = (+monthlySalary) * (detail.premiumAmount / 100);
			return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;

		}
		if (detail.premiumPercentageProperty == 'client.annualSalary') {
			if (!monthlySalary) {
				return `${detail.premiumAmount} % of Annual Salary`
			}
			const out = (+monthlySalary + 12) * (detail.premiumAmount / 100);
			return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;
		}
		return 'Invalid Property(' + detail.premiumPercentageProperty + ')';
	}

	getCompulsoryPremiums(): string {
		let out = 0;
		for (const line of this.productOffer!.lines) {
			if (line.compulsory) {
				if (line.details[0].premiumType == 'Fixed') {
					out += line.details[0].premiumAmount;
				} else {
					const monthlySalary = this.policyForm!.get('currentSalary')?.value;
					if (line.details[0].premiumPercentageProperty == 'client.monthlySalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary) * (line.details[0].premiumAmount / 100);
					} else if (line.details[0].premiumPercentageProperty == 'client.annualSalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary + 12) * (line.details[0].premiumAmount / 100);
					} else {
						return 'Invalid Property(' + line.details[0].premiumPercentageProperty + ')';
					}
				}
			}
		}
		return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;
	}
	getAddOnPremiums(): string {
		let out = 0;
		for (const line of this.productOffer!.lines) {
			if (line.compulsory == false && line.enabled) {
				if (line.details[0].premiumType == 'Fixed') {
					out += line.details[0].premiumAmount;
				} else {
					const monthlySalary = this.policyForm!.get('currentSalary')?.value;
					if (line.details[0].premiumPercentageProperty == 'client.monthlySalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary) * (line.details[0].premiumAmount / 100);
					} else if (line.details[0].premiumPercentageProperty == 'client.annualSalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary + 12) * (line.details[0].premiumAmount / 100);
					} else {
						return 'Invalid Property(' + line.details[0].premiumPercentageProperty + ')';
					}
				}
			}
		}
		return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;

	}
	getExtendedPremiums(): string {
		let out = 0;
		for (const dependant of this.dependantWrappers) {
			if (dependant.extended) {
				const detail = dependant.extended.details.filter(item => item.fromAge <= dependant.age && (!item.toAge || item.toAge >= dependant.age))[0];
				if (detail.premiumType == 'Fixed') {
					out += detail.premiumAmount;
				} else {
					const monthlySalary = this.policyForm!.get('currentSalary')?.value;
					if (detail.premiumPercentagePropety == 'client.monthlySalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary) * (detail.premiumAmount / 100);
					} else if (detail.premiumPercentagePropety == 'client.annualSalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary + 12) * (detail.premiumAmount / 100);
					} else {
						return 'Invalid Property(' + detail.premiumPercentagePropety + ')';
					}
				}
			}
		}
		return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;
	}
	getTotalPremiums(): string {
		let out = 0;
		for (const line of this.productOffer!.lines) {
			if (line.compulsory || line.enabled) {
				if (line.details[0].premiumType == 'Fixed') {
					out += line.details[0].premiumAmount;
				} else {
					const monthlySalary = this.policyForm!.get('currentSalary')?.value;
					if (line.details[0].premiumPercentageProperty == 'client.monthlySalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary) * (line.details[0].premiumAmount / 100);
					} else if (line.details[0].premiumPercentageProperty == 'client.annualSalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary + 12) * (line.details[0].premiumAmount / 100);
					} else {
						return 'Invalid Property(' + line.details[0].premiumPercentageProperty + ')';
					}
				}
			}
		}
		for (const dependant of this.dependantWrappers) {
			if (dependant.extended) {
				const detail = dependant.extended.details.filter(item => item.fromAge <= dependant.age && (!item.toAge || item.toAge >= dependant.age))[0];
				if (detail.premiumType == 'Fixed') {
					out += detail.premiumAmount;
				} else {
					const monthlySalary = this.policyForm!.get('currentSalary')?.value;
					if (detail.premiumPercentagePropety == 'client.monthlySalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary) * (detail.premiumAmount / 100);
					} else if (detail.premiumPercentagePropety == 'client.annualSalary') {
						if (!monthlySalary) {
							return "CurrentSalary is required";
						}
						out += (+monthlySalary + 12) * (detail.premiumAmount / 100);
					} else {
						return 'Invalid Property(' + detail.premiumPercentagePropety + ')';
					}
				}
			}
		}
		return this.currencyPipe.transform(out, 'ZAR', 'symbol-narrow')!;
	}

	isLineSelected(line: ProductOfferLineDto): boolean {
		return line.compulsory! || line.enabled!;
	}

	toggleLine(line: ProductOfferLineDto, checked: boolean): void {
		if (line.compulsory) {
			line.enabled = true;
		} else {
			line.enabled = checked;
		}
	}

	toggleDependant(input: DependantWrapper, checked: boolean): void {
		input.selected = checked;
	}
	openExtendedCoverModal(input: DependantWrapper) {
		const modalRef = this.modalService.create({
			nzTitle: 'Add Extended Cover',
			nzContent: PolicyExtendedCoverModalComponent,
			nzData: {
				input,
				product: this.product
			},
			nzFooter: null,
			nzWidth: 600
		});
		modalRef.componentInstance!.dependant = input.dependant;
		modalRef.componentInstance!.current = input.extended;
		modalRef.componentInstance!.fromDate = input.fromDate;
		modalRef.componentInstance!.product = this.product!;

		modalRef.afterClose.subscribe(result => {
			input.extended = result.extended;
			input.fromDate = result.fromDate;
		});
	}
	submit() {
		const policy: PolicyDto = {
			id: 0,
			member: this.member,
			product: this.product,
			productOffer: this.productOffer,
			productOfferLines: this.productOffer!.lines.filter(item => item.enabled),
			policyNumber: this.policyForm!.get('policyNumber')!.value,
			policyNumberAlt: this.policyForm!.get('policyNumberAlt')!.value,
			currentSalary: this.policyForm?.get('currentSalary')?.value,
			fromDate: this.policyForm!.get('fromDate')!.value,

			jobTitle: this.policyForm?.get('jobTitle')!.value,
			occupation: this.policyForm?.get('occupation')!.value,
			occupationDate: this.policyForm?.get('occupationDate')!.value,

			beneficiaries: [],
			dependants: this.dependantWrappers
				.filter(item => item.selected || item.extended != null)
				.map(item => ({
					id: 0,
					createdAt: new Date(),
					createdByAgent: undefined as any as AgentDto,
					dependant: item.dependant,
					productExtended: item.extended,
					covered: true,
					fromDate: item.fromDate,
					hashCode: 0
				})),

			policyNumberOwls: this.policyForm?.get('policyNumberOwls')!.value,
			policyNumberIndustry: this.policyForm?.get('policyNumberIndustry')!.value,
			policyNumberMembership: this.policyForm?.get('policyNumberMembership')!.value,
			currentLoanAmount: this.policyForm?.get('currentLoanAmount')!.value,
			employer: this.policyForm?.get('employer')!.value,
			policyGroup: this.policyForm?.get('policyGroup')!.value,
			hashCode: 0
		};
		this.httpServicePolicyService.create(policy).subscribe(result => this.router.navigate(['policy', result.id]));
	}

}

// export class PolicyDependantDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	createdByAgent!: AgentDto;
// 	dependant!: DependantDto;
// 	productExtended?: ProductExtendedDto;
// 	endedAt?: Date;
// 	covered!: boolean;
// }
